import { useEffect, useRef } from 'react';

/**
 * Comportamiento común de los menús desplegables del encabezado: Escape cierra y devuelve el foco
 * al botón, un clic fuera cierra, y al abrir el foco entra al primer elemento. Lo usan el menú de
 * navegación y el de cuenta, con los tres listeners en un solo sitio.
 */
export function usarMenuFlotante(abierto: boolean, cerrar: () => void) {
  const contenedor = useRef<HTMLDivElement>(null);
  const disparador = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (!abierto) return;
    const alTeclear = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        cerrar();
        disparador.current?.focus();
      }
    };
    const alTocarFuera = (e: MouseEvent) => {
      if (!contenedor.current?.contains(e.target as Node)) cerrar();
    };
    window.addEventListener('keydown', alTeclear);
    window.addEventListener('mousedown', alTocarFuera);
    contenedor.current?.querySelector<HTMLElement>('[role="menuitem"]')?.focus();
    return () => {
      window.removeEventListener('keydown', alTeclear);
      window.removeEventListener('mousedown', alTocarFuera);
    };
  }, [abierto, cerrar]);

  return { contenedor, disparador };
}
